import React, { useEffect, useRef } from 'react'
import {  useNavigate } from "react-router-dom";
import { Card, Button } from 'react-bootstrap'
import "./TreatmentOutcome.css";
import { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Store/Reducers/UserReducer"
import Folliculogram from './Folliculogram';
import { Modal } from 'react-bootstrap';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import Swal from "sweetalert2";
import moment from "moment";
import Select from 'react-select';
import $ from "jquery";
import LoginFun from './../../Layout Component/Loginfun';
import 'react-toastify/dist/ReactToastify.css';
import { Flip } from 'react-toastify';
import { toast } from 'react-toastify';
var UserData;
export default function TreatmentOutcome(props) {
    const regex = /^[a-zA-Z0-9\s]*$/;
    UserData = JSON.parse(localStorage.getItem("UData"));
    let UID = localStorage.getItem("UserID");
    let treatment_cycle = localStorage.getItem("Tretmentid");
    const dispatch = useDispatch();
    const logindata = LoginFun();
    const url = process.env.REACT_APP_OXAR_API_URL;
    const [TreatmentDataDetails, setTreatmentDataDetails] = useState();
    const navigate = useNavigate();
    const [livebirth, setlivebirth] = useState([]);
    const [subdiv, setSubDiv] = useState(false);
    const [show, setShow] = useState(false);
    // update data treatment oucome
    const [DateofPreg, setDateofPreg] = useState("");
    const [resultofPreg, setresultofPreg] = useState("");
    const [data, setData] = useState();
    const [updateallergies, setupdateallergies] = useState([]);
    const [countryBirth, setcountryBirth] = useState([]);
    // on submit model

    const data2 = { ...data }
    const handleCountry = (event) => {
        const countryBirth = event.target.value;
        data2.countryOfBirth = countryBirth
        updateModalData(event)
    }

    // ONE LOADER FOR THE PAGE'S CALLS, counted.
    //
    // Three calls run at once when this page opens (the treatment, its outcome
    // details and the country list), and each used to switch the shared loader
    // on and off by itself. The outcome call's error path switched it back ON —
    // and a treatment with no outcome details yet makes that call fail — so the
    // loader never went away and the page, the folliculogram included, sat
    // behind it. Now each call says when it starts and when it has finished
    // (in `finally`, so success and failure both count), and the loader goes
    // off when the last one is done.
    const pending = useRef(0);
    const beginLoad = () => {
        pending.current += 1;
        dispatch(setLoader(true));
    };
    const endLoad = () => {
        pending.current = Math.max(0, pending.current - 1);
        if (pending.current === 0) dispatch(setLoader(false));
    };

    // A date as "YYYY-MM-DD", or "" when there is none. The API writes "no
    // date" as 0001-01-01, and may leave the field out altogether.
    const dayOnly = (value) => {
        if (!value) return "";
        const day = String(value).substring(0, 10);
        return day === "0001-01-01" ? "" : day;
    };

    const getCountryOfBirth = async () => {
        beginLoad();
        try {
            const res = await axios(`${url}/api/Profile/GetCountries`);
            setcountryBirth(res.data?.content || []);
        }
        catch {
            setcountryBirth([]);
        }
        finally {
            endLoad();
        }
    }

    const deleteData = async (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to delete ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    beginLoad();
                    axios.delete(`${url}api/Treatment/Deletepregnancyoutcomedetails?id=${id}`).then((res => {
                        if (res.status === 200) {
                            toast.success('Your record has been deleted', {
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                autoClose: 3000,
                                hideProgressBar: true,
                                transition: Flip,
                                className: 'toast-message'
                            }
                            )
                            getTreatmentOutcome();
                        }
                        else {
                            toast.error('Error while deleting previous pregnancy', {
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                autoClose: 3000,
                                hideProgressBar: true,
                                transition: Flip,
                                theme: "colored"
                            }
                            )
                        }
                    }))
                    // A failed delete used to leave the loader on for good:
                    // nothing caught it, so nothing switched the loader off.
                    .catch(() => {
                        toast.error('Error while deleting previous pregnancy', {
                            autoClose: 3000,
                            hideProgressBar: true,
                            transition: Flip,
                            theme: "colored"
                        });
                    })
                    .finally(endLoad);

                }
            })
        }
        catch (e) {
        }
    }

    useEffect(() => {
        var currentTime = ''
        currentTime = (Math.round(new Date().getTime() / 1000));
        var Expiretime = localStorage.getItem("ExpirretokenTime");
        if (Expiretime < currentTime) {
             dispatch(setLoader(false));
            sessionStorage.getItem('isLoggedIn', false)
            Swal.fire({
                title: 'Session Expired',
                text: "Your session has been expired! Please login again",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Okay',
            }).then(result => {
                logindata.logout();
            })
        }
         getTreatmentDataForDetails();
        getTreatmentOutcome();
        getCountryOfBirth();
    }, []);

    const showtreatmentCard = (value) => {
        setresultofPreg(value);
    }

    const getTreatmentDataForDetails = async () => {
        beginLoad();
        try {
            let MainUserId = localStorage.getItem("Tretmentid");
            const res = await axios(`${url}api/Treatment/GetTreatmentCycleById?id=${MainUserId}`);
            const content = res.data?.content;
            if (content) {
                // Tidied BEFORE it is stored, so the page shows the tidy
                // values. These used to call .substring() on fields that can be
                // missing, which threw and left the treatment unshown.
                content.bcrm_date_time_of_early_outcome = dayOnly(content.bcrm_date_time_of_early_outcome);
                content.firstInjectionDate = dayOnly(content.firstInjectionDate);
                setresultofPreg(content.bcrm_result_of_pregnancy_test);
                setDateofPreg(content.bcrm_date_time_of_early_outcome);
                // The folliculogram draws itself from folliculagramJSON
                // — see <Folliculogram> at the foot of the page.
            }
            setTreatmentDataDetails(content);
        }
        catch {
            // Nothing to show; the page stays usable rather than stuck.
        }
        finally {
            endLoad();
        }
    };
    // ******************************** API for  getting treatment details outcome *********************************************//
    const getTreatmentOutcome = async () => {
        beginLoad();
        try {
            let MainUserId = localStorage.getItem("Tretmentid");
            const res = await axios(`${url}api/Treatment/GetByIdpregnancyoutcomedetails?id=${MainUserId}`);
            if (res.data?.content) {
                setlivebirth(res.data.content);
                $("#PrevTreatmentCycleTable").DataTable();
            } else {
                setlivebirth('');
            }
        }
        catch {
            // A treatment with no outcome details yet lands here. That is an
            // empty list, not a reason to keep the page covered.
            setlivebirth('');
        }
        finally {
            endLoad();
        }
    };

    const updateTreatmentOutcome = async (event) => {
        debugger
        let MainUserId = localStorage.getItem("Tretmentid");
        const DataToPost = {
            id: MainUserId,
            bcrm_date_time_of_early_outcome: DateofPreg,
            bcrm_result_of_pregnancy_test: resultofPreg,
        }
        try {
            dispatch(setLoader(true));
            const res = await axios.put(`${url}/api/Treatment/UpdateTreatmentOutcome`, DataToPost)
            if (res.status === 200) {
                toast.success('Treatment outcome updated successfully!', {
                    autoClose: 5000,
                    hideProgressBar: true,
                    newestOnTop: false,
                    closeOnClick: true,
                    rtl: false,
                    pauseOnFocusLoss: true,
                    draggable: true,
                    pauseOnHover: true,
                    className: 'toast-message'
                }
                )
            }
            else {
                toast.warn('Error while Updating Treatment Outcome', {
                    autoClose: 5000,
                    hideProgressBar: true,
                    newestOnTop: false,
                    closeOnClick: true,
                    rtl: false,
                    pauseOnFocusLoss: true,
                    draggable: true,
                    pauseOnHover: true,
                    className: 'toast-warn'
                }
                )
            }
            dispatch(setLoader(false));
        }
        catch (e) {
            if(e?.response?.data?.errorMessage === "Invalid json"){
                toast.error('Please dont use special characters in fields ', {
                  autoClose: 5000,
                  hideProgressBar: true,
                  newestOnTop: false,
                  closeOnClick: true,
                  rtl: false,
                  pauseOnFocusLoss: true,
                  draggable: true,
                  pauseOnHover: true,
                  theme: "colored"
                }
                )
                dispatch(setLoader(false));
              return
              }
              else{
                toast.error('Error while updating', {
                  autoClose: 5000,
                  hideProgressBar: true,
                  newestOnTop: false,
                  closeOnClick: true,
                  rtl: false,
                  pauseOnFocusLoss: true,
                  draggable: true,
                  pauseOnHover: true,
                  theme: "colored"
                }
                )
                dispatch(setLoader(false));
              return
              }
              dispatch(setLoader(false));
              return
        }
    }
    const checkSpecial = (e) => {
        if (!/^[a-zA-Z0-9\s]*$/.test(e.key)) {
            e.preventDefault();
        }
    }
    const updateModalData = async (updatedvalue) => {
        var name = updatedvalue.target.name;
        var value = updatedvalue.target.value;
        if (data) {
            data[name] = value;
        }
        setupdateallergies(values => ({ ...values, [name]: value, 'patient': UID, 'treatment_cycle': treatment_cycle }));
        if (updateallergies.forenames && updateallergies.surname) {
            setupdateallergies(values => ({ ...values, "Name": updateallergies.forenames + " " + updateallergies.surname, 'patient': UID, 'treatment_cycle': treatment_cycle }));
        }
    }

    const AddPregnancyOutcomeDetails = async () => {
        if (updateallergies.forenames !== undefined && updateallergies.surname !== undefined && updateallergies.gender !== undefined && updateallergies.weight_in_grams !== undefined && updateallergies.delivery_date !== undefined && updateallergies.gestation !== undefined &&
            updateallergies.nhs_number !== undefined && updateallergies.country_of_birth !== undefined && updateallergies.town_or_district_of_birth !== undefined && updateallergies.town_or_district !== undefined &&
            updateallergies.forenames !== "" && updateallergies.surname !== "" && updateallergies.gender !== "" && updateallergies.weight_in_grams !== "" && updateallergies.delivery_date !== "" && updateallergies.gestation !== "" &&
            updateallergies.nhs_number !== "" && updateallergies.country_of_birth !== "" && updateallergies.town_or_district_of_birth !== "" && updateallergies.town_or_district !== "") {
            dispatch(setLoader(true));
            await axios.post(`${url}/api/Treatment/Createpregnancyoutcomedetails`, updateallergies).then((response) => {
                if (response.status === 200) {
                    toast.success('Pregnancy outcome created successfully!', {
                        autoClose: 5000,
                        hideProgressBar: true,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        className: 'toast-message'
                    }
                    )
                    //navigate("/MedicalHistory")
                    setShow(false)
                    getTreatmentOutcome();
                }
                else {

                    toast.error('Error while creating Pregnancy  Outcome', {
                        autoClose: 5000,
                        hideProgressBar: true,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        theme: "colored"
                    }
                    )
                }
                dispatch(setLoader(false));
            }, (error) => {


                if(error?.response?.data?.errorMessage === "Invalid json"){
                    toast.error('Please dont use special characters in fields ', {
                      autoClose: 5000,
                      hideProgressBar: true,
                      newestOnTop: false,
                      closeOnClick: true,
                      rtl: false,
                      pauseOnFocusLoss: true,
                      draggable: true,
                      pauseOnHover: true,
                      theme: "colored"
                    }
                    )
                    dispatch(setLoader(false));
                  return
                  }
                    else{
                        toast.error('Error while creating ', {
                            autoClose: 5000,
                            hideProgressBar: true,
                            newestOnTop: false,
                            closeOnClick: true,
                            rtl: false,
                            pauseOnFocusLoss: true,
                            draggable: true,
                            pauseOnHover: true,
                            theme: "colored"
                        }
                        )
                        dispatch(setLoader(false));
                        return
                    }
                    dispatch(setLoader(false));
                    return
            });
        } else {
            toast.warn('Please fill mandatory fields', {
                autoClose: 5000,
                hideProgressBar: true,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true,
                className: 'toast-warn'
            }
            )
        }
    }

    // Update Pregnancy outcome
    const Updatepregnancyoutcomedetails = async () => {
        if (data.forenames !== "" && data.surname !== "" && data.gender !== "" && data.weight_in_grams !== "" && data.delivery_date !== "" && data.gestation !== "" &&
            data.nhs_number !== "" && data.country_of_birth !== "" && data.town_or_district_of_birth !== "" && data.town_or_district !== "") {
            dispatch(setLoader(true));
            await axios.put(`${url}/api/Treatment/Updatepregnancyoutcomedetails`, data).then((response) => {
                if (response.status === 200) {
                    toast.success('Pregnancy outcome updated successfully!', {
                        autoClose: 5000,
                        hideProgressBar: true,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        className: 'toast-message'
                    }
                    )
                    setShow(false)
                    setData([]);
                    getTreatmentOutcome();
                }
                else {
                    toast.error('Error while Updating Pregnancy Outcome', {
                        autoClose: 5000,
                        hideProgressBar: true,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        theme: "colored"
                    }
                    )
                }
                dispatch(setLoader(false));
            }, (error) => {

                if(error?.response?.data?.errorMessage === "Invalid json"){
                    toast.error('Please dont use special characters in fields ', {
                      autoClose: 5000,
                      hideProgressBar: true,
                      newestOnTop: false,
                      closeOnClick: true,
                      rtl: false,
                      pauseOnFocusLoss: true,
                      draggable: true,
                      pauseOnHover: true,
                      theme: "colored"
                    }
                    )
                    dispatch(setLoader(false));
                  return
                  }

                else{
                    toast.error('Error while Updating Pregnancy Outcome', {
                        autoClose: 5000,
                        hideProgressBar: true,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        theme: "colored"
                    }
                    )
                    dispatch(setLoader(false));
                    return
                }
                dispatch(setLoader(false));
                    return
            });
        } else {
            toast.warn('Please fill mandatory fields', {
                autoClose: 5000,
                hideProgressBar: true,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true,
                className: 'toast-warn'
            }
            )
        }
    }

    const handleClose = () => setShow(false);
    const handleShow = (data) => {
        setData('')
        setShow(true)
        setData(data)
    };
    return (
        <>
            <Card className=" border-0 ">
                <Card.Header className="  contactusfont text-dark ">
                    <div className="row">
                        <div className="col-6">
                            <h5>Treatment With Us </h5>
                        </div>
                        <div className="col-6 text-right">
                            ( {UserData?.firstName} {UserData?.lastName} , {moment(UserData?.birthday).format("DD-MMM-YYYY")} ({UserData?.age}) ,{UserData?.gendercodeName} )
                            &nbsp;    <a type="submit" onClick={() => navigate(-1)}>
                                <i style={{ fontSize: "18px" }} class="fa-solid fa-circle-arrow-left"></i>
                            </a>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Card.Text>
                        <div>
                            <div className='row'>
                                <div className="col-md-1"></div>
                                <div className='col-md-10'>
                                    <div className="card">
                                        <div className='card-header pb-2'><h5 className=' d-flex justify-content-center mt-1 mb-1'>Treatment Details</h5></div>
                                        <div className='card-body'>
                                            <div className='row mb-2 p-2'>
                                                <h5 className='mt-1 mb-1'>Treatment Outcome</h5>
                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        <div className='col-md-5'>
                                                            <label >Result of pregnancy test</label>
                                                        </div>
                                                        <div className='col-md-7'>
                                                            <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name="patientGroups"
                                                                onChange={(e) => showtreatmentCard(e.target.value)}
                                                                defaultValue={TreatmentDataDetails?.bcrm_result_of_pregnancy_test}>
                                                                <option value="null">--Select--</option>
                                                                <option value="2" selected={TreatmentDataDetails?.bcrm_result_of_pregnancy_test === 2}>Negative</option>
                                                                <option value="1" selected={TreatmentDataDetails?.bcrm_result_of_pregnancy_test === 1}>Positive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4 '>
                                                    <div className='row'>
                                                        <div className='row'>
                                                            <div className='col-md-5'>
                                                                <label>Date of pregnancy test</label>
                                                            </div>
                                                            <div className='col-md-7'>
                                                                <input type="date" className="form-control" name="bcrm_date_time_of_early_outcome" 
                                                                defaultValue={DateofPreg} 
                                                                onChange={(e) => setDateofPreg(e.target.value)} 
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4 '>
                                                    <div className='row'>
                                                        <div className='col-md-5'>
                                                            <Button className='btn btn-primary updatetop ' onClick={() => updateTreatmentOutcome()}>UPDATE</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <>
                                                <div className="row p-2 mb-1">
                                                    {
                                                        resultofPreg === 1 &&
                                                        <>
                                                            <h5 className='pb-2'>Pregnancy Outcome Details</h5>
                                                            <div className='col-md-2'>
                                                                <label className="form-check-label" for="inlineRadio1">Live Birth :</label>
                                                                <input class="form-check-input ml-3" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" onClick={() => setSubDiv(!subdiv)} />

                                                            </div>
                                                            <div className='col-md-3'>
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <label class="form-check-label" for="inlineRadio2">Neonatal Death :
                                                                <input className="form-check-input ml-3" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" onClick={() => setSubDiv(false)} />

                                                                </label>

                                                            </div>
                                                            <div className='col-md-3'>

                                                            </div>
                                                        </>
                                                    }
                                                    {
                                                        subdiv ? <>
                                                            <div className='col-md-12 mt-1'>
                                                                <div>
                                                                    <button className='btn btn-primary pb-1' type='button' onClick={handleShow}>Add</button>
                                                                </div>
                                                                <div className="table-responsive pt-1">
                                                                    <table class="table border-0" id="PrevTreatmentCycleTable">
                                                                        <thead class="">
                                                                            <tr>
                                                                                <th> Dilevery Date</th>
                                                                                <th>First Name </th>
                                                                                <th>Last Name</th>
                                                                                <th>Gender</th>
                                                                                <th> NHS Number</th>
                                                                                <th>Gestation </th>
                                                                                <th>Edit/Delete</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {livebirth && livebirth.map((listValue, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td>{moment(listValue.delivery_date).format("DD-MMM-YYYY")}</td>
                                                                                        <td>{listValue.forenames}</td>
                                                                                        <td>{listValue.surname}</td>
                                                                                        <td>{listValue.gender}</td>
                                                                                        <td>{listValue.nhs_number}</td>
                                                                                        <td>{listValue.gestation}</td>
                                                                                        <td>
                                                                                            <i className="fa-solid fa-trash" onClick={() => deleteData(listValue.id)}></i><span>{" "}{" "}</span><span>{" "}{" "}</span>
                                                                                            <i className="fa-solid fa-pencil" disabled={listValue.envelopeid === ""} onClick={() => handleShow(listValue)}></i>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </>
                                                            : null
                                                    }
                                                </div>
                                                <div className='row p-2 bg-light p-2 m-2 border rounded border-border-dark'>
                                                    <div className='row'>
                                                        <div className='col-md-4 '>
                                                            <label>Referring Centre : </label><label> {TreatmentDataDetails?.referringCentre}</label>
                                                            {/* {TreatmentDataDetails?.referringCentre} */}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>First Injection Date : </label>
                                                            <label> {moment(TreatmentDataDetails?.firstInjectionDate).format('DD-MMM-yyyy')}</label>

                                                        </div>
                                                        <div className='col-md-4 '>
                                                            <label>TypeofCycle :  </label><label> {TreatmentDataDetails?.typeofCycle}</label>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label>Treatment Details Sec Diagnosis : </label><label> {TreatmentDataDetails?.secDiagnosis}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Treatment Details Diagnosis : </label><label> {TreatmentDataDetails?.treatmentDetailDiagnosis}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Dose:</label><label>{TreatmentDataDetails?.dose}</label>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label>TimeOfTrigger : </label><label>{TreatmentDataDetails?.timeOfTrigger}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>treatmentType : </label><label>{TreatmentDataDetails?.treatmentType}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Treatment Feature : </label><label>{TreatmentDataDetails?.treatmentFeature}</label>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label>Treatment Details Other Diagnosis  : </label><label>{TreatmentDataDetails?.treatmentDetailsOtherDiagnosis}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Left Ovary : </label><label>{TreatmentDataDetails?.leftOvary}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Right Ovary : </label><label>{TreatmentDataDetails?.rightOvary}</label>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label>Stimulation Location  : </label><label>{TreatmentDataDetails?.stimulationLocation}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>LH : </label><label>{TreatmentDataDetails?.lh}</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Egg Collection : </label><label>{TreatmentDataDetails?.eggCollection}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                            {/* Edit Pregnancy Outcome Details data on edit data       */}
                            <Modal size="lg" show={show} onHide={handleClose} >
                                <Modal.Header closeButton>
                                    <Modal.Title>Pregnancy Outcome Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body >
                                    <div className='row mb-2'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'>First Name <span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input type='text' className="form-control" value={data?.forenames}
                                                        placeholder="Enter First Name " name="forenames" onChange={(e) => updateModalData(e)} onKeyDown={(e) => checkSpecial(e)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label ' >Last Name <span className='text-danger'>*</span> </label>

                                                </div>
                                                <div className='col-md-7'>
                                                    <input className='form-control m-1 border-1' value={data?.surname} placeholder='Enter Last Name'
                                                        name="surname" onChange={(e) => updateModalData(e)} onKeyDown={(e) => checkSpecial(e)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'>Gender <span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='gender' value={data?.gender}
                                                        onChange={(e) => updateModalData(e)} >
                                                        <option value="">Select </option>
                                                        <option value="1">Male</option>
                                                        <option value="2">Female</option>
                                                        <option value="3">Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label '>Weight in grams<span className='text-danger'>*</span> </label>

                                                </div>
                                                <div className='col-md-7'>
                                                    <input className='form-control m-1  border-1' value={data?.weight_in_grams} onKeyDown={(e) => checkSpecial(e)}
                                                        placeholder='Enter Weight in grams' name="weight_in_grams" onChange={(e) => updateModalData(e)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'>Delivery Date <span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input type="date" className='form-control m-1  border-1' value={data?.delivery_date}
                                                        placeholder='Enter Delivery Date' name="delivery_date" onChange={(e) => updateModalData(e)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label '>Gestation in weeks<span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input type="number" className='form-control m-1  border-1' value={data?.gestation} placeholder='Enter Gestation in weeks'
                                                        name="gestation" onChange={(e) => updateModalData(e)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'>NHS number <span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input type="number" className='form-control m-1  border-1' value={data?.nhs_number}
                                                        placeholder='Enter NHS number' name="nhs_number" onChange={(e) => updateModalData(e)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label '>Country of Birth<span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <select className='form-control form-select' name='country_of_birth'
                                                        onChange={(e) => handleCountry(e)} value={data?.country_of_birth} >
                                                        <option value="">--Select--</option>
                                                        <Select classNamePrefix="pp-select" onChange={(e) => handleCountry(e)} />
                                                        {countryBirth ? (countryBirth?.map((country, index) => {
                                                            return (
                                                                <option value={country?.id}>{country?.friendlyName}</option>
                                                            );
                                                        })
                                                        ) : null
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'>Town or District of Birth <span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input className='form-control m-1  border-1' value={data?.town_or_district_of_birth} placeholder='Enter Town or District of Birth'
                                                        name="town_or_district_of_birth" onChange={(e) => updateModalData(e)} onKeyDown={(e) => checkSpecial(e)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <label className=' col-form-label'> Town or District<span className='text-danger'>*</span> </label>
                                                </div>
                                                <div className='col-md-7'>
                                                    <input className='form-control m-1  border-1' value={data?.town_or_district} placeholder='Enter Town or District'
                                                        name="town_or_district"
                                                        onKeyDown={(e) => checkSpecial(e)}
                                                        onChange={(e) => updateModalData(e)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    {data?.id ? <Button type="button" className=' btn btn-primary me-2' onClick={() => Updatepregnancyoutcomedetails()} >Update</Button>
                                        : <Button type="button" className=' btn btn-primary me-2' onClick={() => AddPregnancyOutcomeDetails()} >Add</Button>}
                                    <Button variant="secondary" className='btn btn-primary' onClick={handleClose}>Close</Button>
                                </Modal.Footer>
                            </Modal>
                            {/* The folliculogram grid with its graphs below —
                                read only, opening on the latest version. */}
                            {TreatmentDataDetails && <Folliculogram json={TreatmentDataDetails.folliculagramJSON} />}
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>
        </>
    )
}
